import { useGetUserStatisticsQuery } from 'api/StatisticsEndPoints';
import { useGetUserQuery } from 'api/UsersEndPoints';
import dayjs from 'dayjs';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import UserStats from 'modules/Users/userStats/UserStats';
import DatePicker from 'react-datepicker';
import { useParams } from 'react-router-dom';
import { setFrom, setTo } from 'shared/reducers/userStatsSlice';

const now = dayjs().endOf('day');

const UserStatsPage = () => {
  const dispatch = useAppDispatch();
  const { id } = useParams();

  const from = useAppSelector(state => state.userStats.from);
  const to = useAppSelector(state => state.userStats.to);

  const fromDate = dayjs(from);
  const toDate = dayjs(to);

  const { data: user } = useGetUserQuery(Number(id));

  const { data } = useGetUserStatisticsQuery(
    {
      where: {
        userId: Number(id),
        date: {
          between: [from, to],
        },
      },
      order: ['date asc'],
    },
    {
      skip: !id,
    },
  );

  if (!user) return null;

  const logs = data ?? [];

  const onFromChange = (date: Date | null) => {
    if (date) {
      dispatch(setFrom(dayjs(date).startOf('day').toISOString()));
    }
  };

  const onToChange = (date: Date | null) => {
    if (date) {
      dispatch(setTo(dayjs(date).endOf('day').toISOString()));
    }
  };

  return (
    <div className="w-3/4">
      <div className="page-title text-left">
        {user.firstName} {user.lastName} <span style={{ fontSize: '1.2rem' }}>{user.email}</span>
      </div>
      <div className="mb-l flex">
        <div className="mr-m">Activities from</div>
        <DatePicker
          maxDate={now.toDate()}
          selected={fromDate.toDate()}
          onChange={onFromChange}
          customInput={<div>{fromDate.format('DD/MM/YYYY')}</div>}
        />
        <div className="mx-m">to</div>
        <DatePicker
          maxDate={now.toDate()}
          selected={toDate.toDate()}
          onChange={onToChange}
          customInput={<div>{toDate.format('DD/MM/YYYY')}</div>}
        />
      </div>
      <div>
        <UserStats logs={logs} />
      </div>
    </div>
  );
};

export default UserStatsPage;
